module.exports = __webpack_public_path__ + "../resources/images/readingPaneBottomLarge-59441fbd5f5c61335f3fcaa3202d615f.svg";